import { invokeHttp } from './api'

export const provincehospitals = (province) =>
  invokeHttp('/admin/resource/provincehospitals', { province })

export const provinces = () =>
  invokeHttp('/admin/resource/provinces', {})

export const districts = (province) =>
  invokeHttp('/admin/resource/districts', { province })

export const subdistricts = (province, district) =>
  invokeHttp('/admin/resource/subdistricts', { province, district })
